import React from "react";
import hash from "object-hash";

import L from "leaflet";
import { xy_to_bounds } from "./vid_config";

export default class VideoData {
  constructor(data, collection = "light") {
    Object.assign(this, data);

    this.hash = hash(this.filename).slice(0, 6);

    this.url = `https://lifeundertheice.org/${this.x}/${this.y}/${this.hash}${
      collection === "dark" ? "#dark" : ""
    }`;
    this.analyticsUrl = `/${this.x}/${this.y}/${this.filename}`;

    this.bounds = () =>
      new L.LatLngBounds(
        xy_to_bounds(this.x, this.y)[0],
        xy_to_bounds(this.x, this.y)[1]
      );
    this.stillUrl =
      collection === "dark"
        ? `/dark-stills/${data.filename}.jpg`
        : `https://lifeundertheice.s3.amazonaws.com/${data.filename}.jpg`;
    this.screenshot =
      collection === "dark"
        ? `https://lifeundertheice.org${this.stillUrl}`
        : this.stillUrl;
    this.info = () => ({
      url: this.url,
      title: data.title,
      desc: (
        <>
          {data.location}
          <br />
          {data.magnification}
        </>
      ),
    });
  }
}
